export const RAG_COMPONENT_VIEW_LABELS = {
    case_analysis: 'Case analysis',
    medical_chronology: 'Medical chronology',
    sourced_timeline: 'Sourced timeline',
    readiness: 'Readiness',
    case_evidence_digest: 'Case evidence',
    native_table: 'Table preview',
    capability_registry: 'Capabilities',
    calendar_draft: 'Calendar draft',
    email_draft: 'Email draft',
};

const RAG_COMPONENT_TEXT_VIEW_COOKIE = 'jane_rag_component_text_view_types';

export const getSavedRagComponentTextViewTypes = (getCookieFn) => {
    const raw = String(getCookieFn(RAG_COMPONENT_TEXT_VIEW_COOKIE) || '').trim();
    if (!raw) return new Set();
    return new Set(raw.split('|').map(value => value.trim()).filter(Boolean));
};

export const saveRagComponentTextViewTypes = (setCookieFn, types) => {
    setCookieFn(RAG_COMPONENT_TEXT_VIEW_COOKIE, Array.from(types).sort().join('|'), 365);
};
